import { IDirectoryRecord } from '../directory.state';

export enum IRestructuredContactsByPhoneNumberActionTypes {
    SET_RESTRUCTURED_CONTACTS_BY_PHONE_NUMBER = 'SET_RESTRUCTURED_CONTACTS_BY_PHONE_NUMBER',
    SET_RESTRUCTURED_CONTACTS_BY_PHONE_NUMBER_PROCESSING = 'SET_RESTRUCTURED_CONTACTS_BY_PHONE_NUMBER_LOADING',
}

export interface IRestructuredDirectoryContactsState {
    contactsWithKeyAsPhoneNumber: Record<string, IDirectoryRecord>;
    isProcessing?: boolean;
}
